export const decodeFilenameMixin = {
  methods: {
    /**
     * レスポンスヘッダーからファイル名をデコードする。
     *
     * @param {string} contentDisposition - レスポンスヘッダーの値
     * @returns {string} デコードされたファイル名。ファイル名が存在しない場合は 'ファイル名不明' を返します。
     */
    decodeFileName(contentDisposition) {
      const defaultFilename = 'ファイル名不明'
      if (!contentDisposition) {
        return defaultFilename
      }
      const match = contentDisposition.match(/filename\*=UTF-8''(.+\.csv)/)
      if (match && match[1]) {
        return decodeURIComponent(match[1].replace(/\.csv$/, ''))
      }
      return defaultFilename
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/decodeFileName.js